'use strict';

// Import module
import './module/svg';
// Sass Import
import '../Sass/style.scss';
